import 'alpinejs';

let Turbolinks = require("turbolinks")
Turbolinks.start()